import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ParamsCalendarItemId = {
  calendar_item_id: string;
};

export type ProgramsProgramCohortScheduleItemModel =
  ProgramsProgramCohortModel & ParamsCalendarItemId;

export default class ProgramsProgramCohortScheduleItemRoute extends Route<ProgramsProgramCohortScheduleItemModel> {
  @service declare store: Store;

  model(params: ParamsCalendarItemId) {
    return {
      ...(this.modelFor(
        'programs.program.cohort'
      ) as ProgramsProgramCohortModel),
      ...params,
    };
  }
}
